import { render, staticRenderFns } from "./GeneralSiteSetting.vue?vue&type=template&id=015c4171"
import script from "./GeneralSiteSetting.vue?vue&type=script&lang=js"
export * from "./GeneralSiteSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports